import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class PositionPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.positionRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.positionImport,
    );
    this.positionAutocomplete = permissionChecker.match(
      Permissions.values.positionAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.positionCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.positionEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.positionDestroy,
    );
  }
}
